import React from "react";

import ModalAddUserHeader from "../header/header";
import ModalAddUserProjectUsers from "../project-users/project-users";
import ModalAddUserCompanyUsers from "../company-users/company-users";
import ModalAddUserNewUser from "../new-user/new-user";
import ModalAddUserSubmit from "../submit/submit";

export default function ModalAddUserTaskUsersForm(props) {

    const stopPropagation = (e) => {
        e.stopPropagation();
        e.preventDefault();
    }

    const search = props.search ? props.search.trim().toLowerCase() : false;

    // init company users
    let companyUsers = [];
    // only regular users and company managers can see company users
    if (gd.ac.check.company.canSeeCompanyUsers()) {
        if (search) {
            props.companyUsers.map(cu=>{
                if (cu.user.name.toLowerCase().includes(search) === true) companyUsers.push(cu);
            });
        } else {
            companyUsers = props.companyUsers;
        }
    }

    // init project users
    let projectUsers = [];
    if (search) {
        props.projectUsers.map(pu=>{
            if (pu.user.name.toLowerCase().includes(search)) projectUsers.push(pu);
        });
    } else {
        projectUsers = props.projectUsers;
    }

    // this form is also used for chat ad user and there may be no project id
    const curUserProjectAccess = props.projectId ? gd.session.projects.get(props.projectId).access : null;

    if (!projectUsers || projectUsers.length<1) projectUsers = false;
    if (!companyUsers || companyUsers.length<1 ||
        curUserProjectAccess === gd.const.project.access.LIMITED) companyUsers = false;

    const mainClasses = Classes('main',{
        multiselect: props.multiselect
    });

    // 'add-user'
    const modalClasses = Classes('v4-container', 'placement-middle',{
        multiselect: props.multiselect
    });

    return (
        <div className={modalClasses} onClick={stopPropagation}>

            <ModalAddUserHeader search={props.search}
                                onSearchChange={props.onSearchChange}
                                onSearchCancel={props.onSearchCancel}
                                closeModal={props.closeModal}/>

            <div className={mainClasses}>

                {projectUsers && <div className="group-name m-b-20">Project users</div>}

                <ModalAddUserProjectUsers projectUsers={projectUsers}
                                          selected={props.selected}
                                          multiselect={props.multiselect}
                                          onUserClick={props.onUserClick}/>

                {companyUsers && <div className="group-name m-b-20 m-t-20">Company users</div>}

                <ModalAddUserCompanyUsers companyUsers      = {companyUsers}
                                          selected          = {props.selected}
                                          multiselect       = {props.multiselect}
                                          mode              = {props.mode}
                                          showDepartments   = {props.showDepartments}
                                          projectId         = {props.projectId}
                                          onAccessSelect    = {props.onAccessSelect}
                                          onUserClick       = {props.onUserClick}
                                          onUserAdd         = {props.onUserAdd}/>

                <ModalAddUserNewUser />

                {!projectUsers && !companyUsers && <div className="not-found">No users found</div>}

            </div>

            <ModalAddUserSubmit mode={props.mode}
                                multiselect={props.multiselect}
                                canSubmit={props.canSubmit}
                                onClickSubmit={props.onClickSubmit}/>
        </div>
    );
}